import { useEffect, useState } from "react";
import { MultiSelect } from "src/@/components/ui/multi-select";
import useAuth from "src/hooks/useAuth";
import v2_actionListaTagsChats from "src/actions/v2/chats/v2_actionListaTagsChats";


const ChatAddTag = ({ block, changeBlock }) => {
    const { cliente } = useAuth();
    const [listaTags, setListaTags] = useState([]);
    const [tags, setTags] = useState([]);

    console.log('listaTags', listaTags)

    const tagsOptions = [{"_id":"636ae327d964af470a256820","nome":"Indeciso","date":"2022-11-11T00:00:00.000Z","cliente_id":"61e1638610ca0d4f84949d51","descontinuado":false,"cor_hex":"#ccc","usuario_id":"62b533b83b47d82c9167aaa9"},{"_id":"6500d3b7d207a43c31f631a0","nome":"Cliente loja","date":"2022-11-11T00:00:00.000Z","cliente_id":"61e1638610ca0d4f84949d51","descontinuado":false,"cor_hex":"#ccc","usuario_id":"62b533b83b47d82c9167aaa9"},{"_id":"6500d489d207a43c31f631a1","nome":"Cliente teste ","date":"2022-11-11T00:00:00.000Z","cliente_id":"61e1638610ca0d4f84949d51","descontinuado":false,"cor_hex":"#ff0033","usuario_id":"62b533b83b47d82c9167aaa9"},{"_id":"6500eea8d8b7d0f4f89855b3","nome":"negociando","date":"2022-11-11T00:00:00.000Z","cliente_id":"61e1638610ca0d4f84949d51","descontinuado":false,"cor_hex":"#ff0033","usuario_id":"62b533b83b47d82c9167aaa9"},{"_id":"6500eee9d8b7d0f4f89855b5","nome":"propondo","date":"2022-11-11T00:00:00.000Z","cliente_id":"61e1638610ca0d4f84949d51","descontinuado":false,"cor_hex":"#ff0033","usuario_id":"62b533b83b47d82c9167aaa9"},{"_id":"651a30d44672324cd822d107","nome":"Campanha","date":"2023-10-02T02:54:12.073Z","usuario_id":"62b533b83b47d82c9167aaa9","cliente_id":"61e1638610ca0d4f84949d51","cor_hex":"#ccc","__v":0},{"_id":"66b102148c357acc943b28bd","usuario_id":"62b533b83b47d82c9167aaa9","cliente_id":"61e1638610ca0d4f84949d51","date":"2024-08-05T16:47:16.285Z","nome":"teste campanha","cor_hex":"#ccc","__v":0}]
  
    useEffect(() => {
      // Atualiza o estado local quando o bloco muda
      if (block?.data?.chatTags) {
        setTags(block?.data?.chatTags);
      }
    }, [block]);
  
    async function buscarListaTags() {
      try {
        const querys = `?cliente_id=${cliente._id}`;
        const response = await v2_actionListaTagsChats(querys);
        setListaTags(response.data.data);
      } catch (error) {
        console.error("Erro ao buscar lista de tags:", error);
      }
    }
  
    useEffect(() => {
      buscarListaTags();
    }, [block]);
  
    const listFormat = listaTags.map((tag) => ({
      value: tag._id,
      label: tag.nome,
    }));
  
    return (
      <div className="w-full">

     
            <MultiSelect
              options={listFormat}
              onValueChange={(selectedValues) => {
                const event = {
                  name: "chatTags",
                  value: selectedValues,
                };
                changeBlock(event); // Notifica o componente pai
              }}
              defaultValue={block?.data?.chatTags} // Usa o estado local
              placeholder="Selecionar tags"
              variant="inverted"
              animation={2}
              maxCount={3}
            />

      </div>
    );
  };
  
  export default ChatAddTag;